export default __webpack_public_path__ + "static/media/RTLG1053.3477c81c.exe";